
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ConfiguracionesPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/configuraciones/resumen', { replace: true });
  }, [navigate]);

  return null;
}
